<template>
    <div class="c-nongye-right">
        <top-tabs :tabsObj="tabsObj" style="border-radius: 16px 16px 0px 0px"></top-tabs>
        <div class="c-nongye-right__search">
            <el-date-picker
                v-model="date"
                type="daterange"
                class="c-nongye-right__picker"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :unlink-panels="true"
                @change="handleDateChange"
            ></el-date-picker>
        </div>
        <YScroll class="c-nongye-right__body" style="height: calc(100% - 10px)">
            <div class="c-nongye-right__inner">
                <div class="c-nongye-right__overview">
                    <div class="c-nongye-right__overview-item" v-for="(item, idx) in overviewList" :key="idx">
                        <img class="c-nongye-right__overview-icon" :src="nongyeIcons[item.url]" :alt="item.name" />
                        <div class="c-nongye-right__overview-text">
                            <div class="c-nongye-right__overview-label">
                                {{ item.name }}<span class="unit" v-if="item.unit">{{ item.unit }}</span>
                            </div>
                            <div class="c-nongye-right__overview-value">{{ item.value }}</div>
                        </div>
                    </div>
                </div>

                <div class="c-nongye-right__session-header">
                    <i class="el-icon-caret-right c-nongye-right__session-header-icon"></i>
                    <span class="c-nongye-right__session-header-text">作物分布</span>
                </div>
                <div class="c-nongye-right__crop">
                    <div class="crop-chart">
                        <!-- echarts容器，替换原来svg -->
                        <div ref="cropChartRef" style="width:150px;height:150px;"></div>
                    </div>
                    <ul class="crop-legend">
                        <li v-for="(item, i) in cropList" :key="i">
                            <span class="dot" :style="{ background: item.color }"></span>
                            <span class="name">{{ item.name }}</span>
                            <span class="value">{{ item.value }}<span class="unit">{{ item.unit }}</span></span>
                        </li>
                    </ul>
                </div>

                <div class="c-nongye-right__session-header">
                    <i class="el-icon-caret-right c-nongye-right__session-header-icon"></i>
                    <span class="c-nongye-right__session-header-text">种植情况</span>
                </div>
                <ul class="c-nongye-right__planting">
                    <li v-for="(item, i) in plantingList" :key="i" class="planting-item">
                        <span class="planting-corner planting-corner--tl"></span>
                        <span class="planting-corner planting-corner--tr"></span>
                        <span class="planting-corner planting-corner--bl"></span>
                        <span class="planting-corner planting-corner--br"></span>
                        <div class="planting-icon" :style="{ background: item.bg }">
                            <img class="planting-icon-img" :src="nongyeIcons[item.icon]" :alt="item.label" />
                        </div>
                        <div class="planting-text">{{ item.label }}</div>
                        <div class="planting-value">{{ item.value }}<span class="unit">{{ item.unit }}</span></div>
                    </li>
                </ul>
            </div>
        </YScroll>
    </div>
</template>

<script>
import { formatDate } from '@Util';
import { YScroll } from '@CommonComponent';
import * as echarts from 'echarts';
import TopTabs from '@/components/topTabs.vue';
import nongyeIcons from '../imgs/index.js';

const COLORS = ['#5bf0fc', '#49f0fd', '#7df5b0', '#ef8200', '#a48bff', '#f56c6c'];

export default {
    name: 'Right',
    components: { TopTabs, YScroll },
    props: {
        overviewList: { type: Array, default: () => [] },
        cropList: { type: Array, default: () => [] },
        plantingList: { type: Array, default: () => [] },
    },
    data() {
        const time = new Date();
        let start = new Date('2026-06-01');
        if (window.gconfig.start) {
            start = new Date(window.gconfig.start);
        }
        return {
            nongyeIcons,
            date: [start, time],
            tabsObj: { centre: '数据统计', type: 3 },
            cropChartInstance: null,
        };
    },
    computed: {
        cropTotal() {
            const total = this.cropList.reduce((s, it) => s + (Number(it.value) || 0), 0);
            return { value: total.toFixed(0), unit: this.cropList[0]?.unit || '' };
        },
    },
    watch: {
        date: {
            handler(newVal, oldVal) {
                this.$emit('handleDateChange', this.getDataParams());
            },
            immediate: true,
            deep: true,
        },
        // prop数据变化更新图表
        cropList: {
            handler() {
                this.updateCropChart();
            },
            deep: true,
        },
    },
    mounted() {
        this.initCropChart();
        window.addEventListener('resize', this.onWindowResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
        if (this.cropChartInstance) {
            this.cropChartInstance.dispose();
            this.cropChartInstance = null;
        }
    },
    methods: {
        onWindowResize() {
            this.cropChartInstance && this.cropChartInstance.resize();
        },
        initCropChart() {
            if (!this.$refs.cropChartRef) return;
            this.cropChartInstance = echarts.init(this.$refs.cropChartRef);
            this.updateCropChart();
        },
        updateCropChart() {
            if (!this.cropChartInstance) return;
            // 构建echarts数据
            const chartData = this.cropList.map((item, idx) => ({
                name: item.name,
                value: Number(item.value) || 0,
                itemStyle: {
                    color: item.color || COLORS[idx % COLORS.length],
                },
            }));

            const option = {
                // 底层背景环，模拟原svg底层 circle rgba(73, 240, 253, 0.15)
                series: [
                    // 底层底色环
                    {
                        type: 'pie',
                        radius: ['72%', '90%'],
                        center: ['50%', '50%'],
                        silent: true,
                        label: { show: false },
                        labelLine: { show: false },
                        data: [{ value: 1, itemStyle: { color: 'rgba(73, 240, 253, 0.15)' } }],
                    },
                    // 实际数据环形
                    {
                        type: 'pie',
                        radius: ['62%', '90%'],
                        center: ['50%', '50%'],
                        avoidLabelOverlap: false,
                        label: { show: false },
                        labelLine: { show: false },
                        data: chartData,
                    },
                ],
                graphic: [
                    {
                        type: 'text',
                        left: '34%',
                        top: '32%',
                        style: {
                            text: '总面积',
                            textAlign: 'center',
                            fill: '#fff',
                            fontSize: 16,
                        },
                    },

                    // 中间数字
                    {
                        type: 'text',
                        left: '35%',
                        top: '50%',
                        style: {
                            text: this.cropTotal.value,
                            textAlign: 'center',
                            fill: '#fff',
                            fontSize: 16,
                            fontWeight: 'bold',
                        },
                    },
                    // 中间单位
                    {
                        type: 'text',
                        left: '65%',
                        top: '52%',
                        style: {
                            text: this.cropTotal.unit,
                            textAlign: 'center',
                            fill: '#9bb0d9',
                            fontSize: 12,
                        },
                    },
                ],
            };
            this.cropChartInstance.setOption(option, true);
        },
        getDataParams() {
            let startDate = this.date ? `${formatDate(this.date[0])} 00:00:00` : '';
            let endDate = this.date ? `${formatDate(this.date[1])} 23:59:59` : '';
            let params = { startDate, endDate };
            return params;
        },
        handleDateChange(val) {
            console.log('handleDateChange', val);

            // this.$emit('handleDateChange', val);
        },
    },
};
</script>

<style lang="scss" scoped>
.c-nongye-right {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: #fff;

    &__search {
        padding: 10px 12px 4px;

        ::v-deep .c-nongye-right__picker.el-date-editor.el-range-editor.el-input__inner {
            width: 100%;
            height: 36px;
            background-color: rgba(10, 26, 58, 0.5);
            border: 1px solid #1a47a4;
            border-radius: 4px;
            display: flex;
            align-items: center;
            padding: 0 10px;

            .el-range-input {
                background: transparent;
                color: #ffffff;
                font-size: 13px;
                text-align: center;
                height: 30px;
                line-height: 30px;
            }

            .el-range-input::-webkit-input-placeholder {
                color: #9bb0d9;
            }

            .el-range-input::-moz-placeholder {
                color: #9bb0d9;
            }

            .el-range-input::placeholder {
                color: #9bb0d9;
            }

            .el-range-separator {
                color: #9bb0d9;
                font-size: 13px;
                line-height: 30px;
                width: 24px;
                text-align: center;
            }

            .el-range__icon {
                color: #5bf0fc;
                font-size: 14px;
                margin-right: 4px;
            }
        }
    }

    &__inner {
        padding: 8px 12px 16px;
    }

    &__overview {
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 14px;

        &-item {
            width: 50%;
            box-sizing: border-box;
            padding: 6px 4px 0 0;
            display: flex;
        }
    }

    &__overview-icon {
        width: 38px;
        height: 47px;
        flex-shrink: 0;
    }

    &__overview-text {
        padding-left: 8px;
        min-width: 0;
    }

    &__overview-value {
        font-size: 18px;
        color: #49f0fd;
        font-weight: bold;
        line-height: 1.4;
    }

    &__overview-label {
        font-size: 13px;
        color: #fff;
        padding-bottom: 2px;

        .unit {
            color: #9bb0d9;
            display: inline-block;
            font-size: 11px;
            margin-left: 3px;
        }
    }

    &__crop {
        display: flex;
        align-items: center;
        gap: 8px;
        background: rgba(10, 26, 58, 0.5);
        border: 1px solid #1a47a4;
        border-radius: 4px;
        padding: 12px;
    }

    &__session-header {
        width: 100%;
        height: 30px;
        line-height: 40px;
        background: linear-gradient(90deg, rgba(10, 167, 255, 0.4) 0%, rgba(10, 167, 255, 0) 100%);
        border: 1px solid;
        border-image: linear-gradient(34deg, rgba(73, 240, 253, 0.6), rgba(73, 240, 253, 0)) 1 1;
        border-left: transparent;
        border-right: transparent;
        margin: 8px 0 8px;
        display: flex;
        align-items: center;
        padding: 0 ;

        &-icon {
            color: #ef8200;
            font-size: 18px;
            margin-right: 6px;
        }

        &-text {
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            line-height: 18px;
            color: #ffffff;
        }
    }

    .crop-chart {
        flex: 0 0 100px;
        height: 150px;
    }

    .crop-legend {
        flex: 1;
        list-style: none;
        margin: 0;
        padding: 0;
        font-size: 12px;
        line-height: 22px;

        li {
            display: flex;
            align-items: center;

            .dot {
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-left: 15px;
                margin-right: 6px;
            }

            .name {
                color: #fff;
                margin-right: 6px;
            }

            .value {
                color: #49f0fd;
                font-weight: 500;

                .unit {
                    font-size: 10px;
                    color: #9bb0d9;
                    margin-left: 2px;
                }
            }
        }
    }

    &__planting {
        list-style: none;
        margin: 0;
        padding: 0;

        .planting-item {
            position: relative;
            display: flex;
            align-items: center;
            padding: 8px 10px;
            background: rgba(10, 26, 58, 0.5);
            border: 1px solid #1a47a4;
            border-radius: 4px;
            margin-bottom: 6px;
        }

        .planting-corner {
            position: absolute;
            width: 8px;
            height: 8px;
            pointer-events: none;
        }

        .planting-corner--tl {
            top: -1px;
            left: -1px;
            border-top: 1px solid #ef8200;
            border-left: 1px solid #ef8200;
        }

        .planting-corner--tr {
            top: -1px;
            right: -1px;
            border-top: 1px solid #ef8200;
            border-right: 1px solid #ef8200;
        }

        .planting-corner--bl {
            bottom: -1px;
            left: -1px;
            border-bottom: 1px solid #ef8200;
            border-left: 1px solid #ef8200;
        }

        .planting-corner--br {
            bottom: -1px;
            right: -1px;
            border-bottom: 1px solid #ef8200;
            border-right: 1px solid #ef8200;
        }

        .planting-icon {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            color: #fff;
            font-size: 18px;
        }

        .planting-icon-img {
            width: 20px;
            height: 20px;
            object-fit: contain;
        }

        .planting-text {
            flex: 1;
            font-size: 13px;
            color: #fff;
        }

        .planting-value {
            font-size: 16px;
            color: #49f0fd;
            font-weight: bold;

            .unit {
                font-size: 10px;
                color: #9bb0d9;
                margin-left: 2px;
            }
        }
    }
}
</style>
